import React, { useState } from "react";
import contact from "../../assets/fake-data/landingpage-three/contact";

const GetInTouch = () => {
  const [dataBlock] = useState({
    title: "Get In Tuch With Us With Any Questions",
    subTitle:
      " Due to its widespread use as filler text for layouts, non-readability is of great importance.",
  });
  return (
    <>
      <section className="py-20">
        <div className="container">
          <div className="grid grid-cols-1">
            <div className="text-center">
              <h2 className="font-bold text-[32px] md:text-[40px] capitalize mb-2 relative z-10">
                <span className="bg-[#dff1f0] h-[70px] w-[70px] inline-block absolute rounded-full -z-10 -top-[15px]"></span>
                {dataBlock.title}
              </h2>
              <p className="text-muted mx-auto text-lg max-w-[600px] mt-6">
                {dataBlock.subTitle}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 mt-16">
            <div className="max-w-[500px] w-full mx-auto">
              <form className="space-y-6">
                <div>
                  <input
                    type="email"
                    className="form-input rounded-md !h-[55px] bg-white border !border-[#ced4da] focus:!border-custom"
                    placeholder="Your email..."
                    required=""
                  />
                </div>
                <div>
                  <textarea
                    rows="5"
                    className="form-input rounded-md bg-white border !border-[#ced4da] focus:!border-custom h-auto"
                    placeholder="Your message..."
                    required=""
                    spellCheck="false"
                  ></textarea>
                </div>
                <div>
                  <button type="button" className="btn-custom w-full">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="bg-dark/[0.04] h-[1px] my-[70px] w-full inline-block"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
            {contact.map((x) => {
              return (
                <div key={x.id} className="text-center">
                  <div className="bg-custom/20 w-[50px] h-[50px] flex items-center mx-auto justify-center leading-[50px] rounded-lg">
                    <img
                      src={x.img}
                      alt="mail"
                      className="mx-auto inline-block h-[30px]"
                    />
                  </div>
                  <h4 className="mt-4 font-bold text-xl">{x.name}</h4>
                  <p className="mt-2 text-muted">{x.text}</p>
                  <p className="mt-1 text-muted">{x.subText}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default GetInTouch;
